import React, { useState, useEffect } from "react";
import { NavLink } from 'react-router-dom';
import "./Navbar.css";
import { Nav, Navbar as BootstrapNavbar, Button } from "react-bootstrap";
import logo from "./assets/logo.jpg";
import FixedNavbar from './FixedNavbar';

const importGoogleFonts = () => {
  const link = document.createElement("link");
  link.href = "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500&display=swap";
  link.rel = "stylesheet";
  document.head.appendChild(link);
};

const TimeSupportRow = () => {
  const [japanTime, setJapanTime] = useState(new Date().toLocaleTimeString('en-US', { timeZone: 'Asia/Tokyo', hour12: false }));

  useEffect(() => {
    const timer = setInterval(() => {
      setJapanTime(new Date().toLocaleTimeString('en-US', { timeZone: 'Asia/Tokyo', hour12: false }));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="time-support-row">
      <div className="container">
        <Button variant="" className="japan-time-btn jpt-supp">
          Japan Time: {japanTime}
        </Button>
        <Button variant="" className="support-btn jpt-supp">
          Support
        </Button>
      </div>
    </div>
  );
};

const Navbar = () => {
  useEffect(() => {
    importGoogleFonts();
  }, []);

  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [ishowtoOpen, setIshowtoOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!window.localStorage.getItem("token"));

  useEffect(() => {
    const checkLoginStatus = () => {
      setIsLoggedIn(!!window.localStorage.getItem("token"));
    };

    checkLoginStatus();
    window.addEventListener("storage", checkLoginStatus);

    return () => {
      window.removeEventListener("storage", checkLoginStatus);
    };
  }, []);

  const handleAboutMouseEnter = () => setIsAboutOpen(true);
  const handleAboutMouseLeave = () => setIsAboutOpen(false);
  const handleAboutClick = () => setIsAboutOpen((prev) => !prev);

  const handleHowtoMouseEnter = () => setIshowtoOpen(true);
  const handleHowtoMouseLeave = () => setIshowtoOpen(false);
  const handleHowtoClick = () => setIshowtoOpen((prev) => !prev);

  const handleServicesMouseEnter = () => setIsServicesOpen(true);
  const handleServicesMouseLeave = () => setIsServicesOpen(false);
  const handleServicesClick = () => setIsServicesOpen((prev) => !prev);

  return (
    <div>
      <FixedNavbar />
      <TimeSupportRow />
      <BootstrapNavbar expand="md" className="shadow-sm py-2 navbody" id="nav">
        <div className="container">
          <NavLink to="/" className="navbar-brand">
            <img src={logo} alt="Logo" className="logo" />
          </NavLink>
          <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
          <BootstrapNavbar.Collapse id="basic-navbar-nav">
            
            <Nav className="me-auto">
              <NavLink to="/" className="nav-link">Home</NavLink>

              <Nav.Item
                className="nav-item nav-dropdown"
                onMouseEnter={handleAboutMouseEnter}
                onMouseLeave={handleAboutMouseLeave}
                onClick={handleAboutClick}
              >
                <NavLink className="nav-link">
                  About Us
                </NavLink>
                <div className={`dropdown-menu ${isAboutOpen ? "show" : ""}`}>
                  <NavLink to="/about-us/company-profile" className="dropdown-item">
                    Company Profile
                  </NavLink>                  
                </div>
              </Nav.Item>

              <NavLink to="/inventory" className="nav-link">Inventory</NavLink>

              <NavLink to="/bank-details" className="nav-link">Bank Details</NavLink>  

              <Nav.Item
                className="nav-item nav-dropdown"
                onMouseEnter={handleServicesMouseEnter}
                onMouseLeave={handleServicesMouseLeave}
                onClick={handleServicesClick}
              >
                <NavLink className="nav-link">
                  Services
                </NavLink>
                <div className={`dropdown-menu ${isServicesOpen ? "show" : ""}`}>
                  <NavLink to="/services/how-to-buy" className="dropdown-item">
                    How to Buy
                  </NavLink>
                  <NavLink to="/services/customer-review" className="dropdown-item">
                    Car Reviews
                  </NavLink>
                  <NavLink to="/services/faq" className="dropdown-item">
                    FAQ
                  </NavLink>
                </div>
              </Nav.Item>

              <NavLink to="/contact" className="nav-link">Contact Us</NavLink>

            </Nav>

            <Nav>

              <NavLink to="/" className="nav-link text-purple-600 heartbox">
                <i className="bi bi-heart-fill"></i> Saved
              </NavLink>

              <NavLink to={isLoggedIn ? "/admin-panel" : "/sign-in"} className="nav-link">
                {isLoggedIn ? "Dashboard" : "Sign In"}
              </NavLink>

            </Nav>
            
          </BootstrapNavbar.Collapse>
        </div>
      </BootstrapNavbar>
    </div>
  );
};

export default Navbar;